<div class="capital-input-container d-flex" 
     [class.active]="isFocused" 
     [class.disabled]="isDisabled"
     (click)="capitalInput.focus()"
     (keydown.enter)="capitalInput.focus()">
    <span class="capital-placeholder" 
          [class.active]="value || isFocused"
          [class.no-transition]="isInitialLoad && value">
        {{ placeholder() }}</span>
    <input [type]="type()" 
           class="capital-input" 
           #capitalInput 
           [value]="value"
           [disabled]="isDisabled"
           (focus)="isFocused = true" 
           (blur)="onBlur()"
           (input)="onInput($event)" 
           (keydown)="onKeyDown($event)">
</div>